<div class="context-container">
  <div (click)="clickOpen($event)" #contextButton>
    <ng-content select="[contextButton]"></ng-content>
  </div>
  <ng-template #contextMenu>
    <ng-content select="[contextContent]"></ng-content>
  </ng-template>
</div>
